import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../common/Button';
import styles from './ActivationHeader.module.scss';

function ActivationHeader(props) {
  const {
    supplier: { small_logo_path, name },
  } = props.supplierData;

  return (
    <div className={styles.container}>
      <div>
        <img src={small_logo_path} alt={name} />
      </div>

      <h4>{name}</h4>

      <div className={styles.buttons}>
        <Button uppercase={false} text="ADD eCom INTEGRATION" onClick={props.open} />
      </div>
    </div>
  );
}

export default ActivationHeader;

ActivationHeader.propTypes = {
  open: PropTypes.func.isRequired,
  supplierData: PropTypes.object.isRequired,
};
